import type { FC } from 'react'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { EColor } from '@frontend/pole-ui/lib/common/constants'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import format from 'date-fns/format'
import { Skeleton } from '@/components/ui'
import { EJournalRoute } from '@/types'
import { useFormatPublicationDate } from '@/utils/hooks/format/useFormatPublicationDate'
import { createRouterLink } from '@/utils/url'
import { additionalAsideNews, mainAsideNews } from './constants'
import type { IAsideNewsPreviewProps } from './interface'
import './styles.scss'

const AsideNewsPreview: FC<IAsideNewsPreviewProps> = props => {
  const { titleId, news = [], mainNewsBackgroundColor = EColor.LIGHT_GRAY, isLoading, commonNewsTextId, commonNewsUrl, onClick } = props
  const { slug: firstNewsSlug, title: firstNewsTitle, publicationDate: firstNewsPublicationDate, type } = news[0] || {}
  const { formatPublicationDate } = useFormatPublicationDate(type)

  return (
    <div className="journal-page hidden-md" onClick={onClick}>
      <aside className="aside-news-preview">
        <h3 className="space-holder24">
          <FormattedMessage id={titleId} />
        </h3>

        <Skeleton isLoading={isLoading} skeletons={mainAsideNews}>
          <article className={'space-holder32 aside-news-preview-main-news'} style={{ backgroundColor: mainNewsBackgroundColor }}>
            <CommonLink url={firstNewsSlug && createRouterLink(EJournalRoute.PUBLICATION_ITEM, { publicationSlug: firstNewsSlug })}>
              <h4 className="aside-news-preview-main-news__title">{firstNewsTitle}</h4>
              {firstNewsPublicationDate && (
                <p className="text_super-small color_pale-black">
                  <time itemProp="publishedDate" dateTime={format(new Date(firstNewsPublicationDate), 'yyyy-MM-dd')}>
                    {formatPublicationDate(firstNewsPublicationDate)}
                  </time>
                </p>
              )}
            </CommonLink>
          </article>
        </Skeleton>

        <div className={'aside-news-preview-simple-news-list'}>
          <Skeleton isLoading={isLoading} skeletons={additionalAsideNews}>
            {news.slice(1, 4).map(({ slug, title, publicationDate }) => (
              <article key={slug} className={'aside-news-preview-simple-news-item'}>
                <h2 className="h5 font_base font-weight_normal aside-news-preview-simple-news-item__title">
                  <CommonLink url={createRouterLink(EJournalRoute.PUBLICATION_ITEM, { publicationSlug: slug })}>{title}</CommonLink>
                </h2>
                {publicationDate && (
                  <p className="text_super-small color_pale-black">
                    <time itemProp="publishedDate" dateTime={format(new Date(publicationDate), 'yyyy-MM-dd')}>
                      {formatPublicationDate(publicationDate)}
                    </time>
                  </p>
                )}
              </article>
            ))}
            <CommonLink className="color_green underline underline_green text_body space-holder-top24-md" url={commonNewsUrl}>
              <FormattedMessage id={commonNewsTextId} />
            </CommonLink>
          </Skeleton>
        </div>
      </aside>
    </div>
  )
}

export default AsideNewsPreview
